"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const InviteStage_1 = __importDefault(require("../../components/invite/InviteStage"));
const InviteStore_1 = __importDefault(require("../../stores/InviteStore"));
const InviteSuccess_1 = __importDefault(require("../../components/invite/InviteSuccess"));
const InviteViewStyled_1 = __importDefault(require("./InviteViewStyled"));
const LoginRequired_1 = __importDefault(require("../../components/redeem/LoginRequired"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
const epic_alt_utils_1 = require("epic-alt-utils");
const query_string_1 = __importDefault(require("query-string"));
/**
 * InviteView
 *
 * Rendered when the Route matches /invite
 */
let InviteView = class InviteView extends react_1.default.Component {
    static getStores() {
        return [InviteStore_1.default];
    }
    static getPropsFromStores() {
        return {
            inviteStore: InviteStore_1.default.getState()
        };
    }
    render() {
        const { isLoggedIn } = this.props;
        let inviteViewContent;
        if (!isLoggedIn || this.props.inviteStore.currentStage === 'LOGIN') {
            const code = this.props.location.search ? query_string_1.default.parse(this.props.location.search).code || '' : '';
            const loginPath = `${this.props.location.pathname}?code=${code}`;
            inviteViewContent = react_1.default.createElement(LoginRequired_1.default, { returnPath: loginPath, signupDisabled: true });
        }
        else {
            switch (this.props.inviteStore.currentStage) {
                case 'INVITE':
                    inviteViewContent = (react_1.default.createElement(InviteStage_1.default, { inviteStore: this.props.inviteStore, loadScreen: this.props.loadScreen, isLoggedIn: isLoggedIn, nextStage: "SUCCESS" }));
                    break;
                case 'SUCCESS':
                    inviteViewContent = react_1.default.createElement(InviteSuccess_1.default, { inviteStore: this.props.inviteStore });
                    break;
                default:
                    return true;
            }
        }
        return react_1.default.createElement(InviteViewStyled_1.default, { className: "inviteView" }, inviteViewContent);
    }
};
InviteView.propTypes = {
    location: prop_types_1.default.object,
    inviteStore: prop_types_1.default.object,
    isLoggedIn: prop_types_1.default.bool,
    loadScreen: prop_types_1.default.node
};
InviteView = __decorate([
    epic_alt_utils_1.connectToStores
], InviteView);
exports.default = InviteView;
//# sourceMappingURL=InviteView.js.map